export const GLOBAL_EANS_RESET_STATE = 'GLOBAL_EANS_RESET_STATE';
export const GLOBAL_EANS_CURRENT_ITEM = 'GLOBAL_EANS_CURRENT_ITEM';

export const GLOBAL_EANS_REQUEST_LOADING = 'GLOBAL_EANS_REQUEST_LOADING';
export const GLOBAL_EANS_REQUEST_SUCCESS = 'GLOBAL_EANS_REQUEST_SUCCESS';
export const GLOBAL_EANS_REQUEST_FAILED = 'GLOBAL_EANS_REQUEST_FAILED';

export const GLOBAL_EANS_CURRENT_ACTION = 'GLOBAL_EANS_CURRENT_ACTION';
export const GLOBAL_EANS_RESET_ACTION = 'GLOBAL_EANS_RESET_ACTION';